import { CalendarCheck, CalendarX } from "lucide-react";

/** Nightly booking-sync outcome for one property. Renders nothing without a calendar link. */
export function CalendarSyncBadge({ property }) {
  if (!property?.ical_url) return null;
  const failed = Boolean(property.ical_sync_error);
  const when = property.ical_sync_attempted_at || property.ical_synced_at;
  const stamp = when
    ? new Date(when).toLocaleString(undefined, { month: "short", day: "numeric",
                                                 hour: "numeric", minute: "2-digit" })
    : null;
  return (
    <span data-testid={`ical-badge-${property._id}`} title={property.ical_sync_error || undefined}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium
        ${failed ? "border-red-200 bg-red-50 text-red-700"
                 : "border-emerald-200 bg-emerald-50 text-emerald-700"}`}>
      {failed ? <CalendarX className="h-3 w-3" /> : <CalendarCheck className="h-3 w-3" />}
      {failed ? "Calendar sync failed" : stamp ? `Synced ${stamp}` : "Calendar linked"}
    </span>
  );
}
